import {
  PaybBillingAddress,
  PaybBillingAddressView,
  ShippingAddress,
  ShippingAddressView,
} from './types';
import { Address, Country, Price } from '@global/types/types';
import { PreviewDeliveryOption } from '@global/utils/orderUtils';
import { SiteConfig } from '@src/global/utils/SiteConfig';

export function mapToView(
  paybBillingAddress: PaybBillingAddress = {
    upaLine1: '',
    upaLine2: '',
    upaCity: '',
    wCountry: '',
    gadStateOrProvince: '',
    gadCountry: {
      name: '',
      numericCode: '',
      iso2Code: '',
    },
    upaPostcode: '',
  }
): PaybBillingAddressView {
  return {
    state: paybBillingAddress?.gadStateOrProvince || '',
    addressOne: paybBillingAddress?.upaLine1 || '',
    addressTwo: paybBillingAddress?.upaLine2 || '',
    city: paybBillingAddress?.upaCity || '',
    zip: paybBillingAddress?.upaPostcode || '',
    uid: paybBillingAddress?.uid || '',
    country: {
      name: paybBillingAddress?.gadCountry?.name,
      numericCode: paybBillingAddress?.gadCountry?.numericCode,
      iso2Code:
        paybBillingAddress?.wCountry ||
        paybBillingAddress?.gadCountry?.iso2Code,
    },
  };
}

export function mapShippingToView(
  shippingAddress: ShippingAddress = {
    upaLine1: '',
    upaLine2: '',
    upaCity: '',
    upaPhoneNumber: '',
    wFirstName: '',
    wLastName: '',
    upaEmail: '',
    wCountry: '',
    gadStateOrProvince: '',
    gadCountry: {
      name: '',
      numericCode: '',
      iso2Code: '',
    },
    upaPostcode: '',
  },
  shippingAddressId = '',
  deliveryInfo?: PreviewDeliveryOption
): ShippingAddressView {
  return {
    state: shippingAddress?.gadStateOrProvince || '',
    addressOne: shippingAddress?.upaLine1 || '',
    addressTwo: shippingAddress?.upaLine2 || '',
    city: shippingAddress?.upaCity || '',
    zip: shippingAddress?.upaPostcode || '',
    uid: shippingAddressId || '',
    phone: shippingAddress?.upaPhoneNumber || '',
    firstName: shippingAddress.wFirstName,
    lastName: shippingAddress.wLastName,
    email: shippingAddress.upaEmail,
    country: {
      name: shippingAddress?.gadCountry?.name,
      numericCode: shippingAddress?.gadCountry?.numericCode,
      iso2Code:
        shippingAddress?.wCountry || shippingAddress?.gadCountry?.iso2Code,
    },
    deliveryInfo,
  };
}

export const buildPrice = (price: Price, negative?: boolean): string => {
  const value = price.value.toFixed(2);
  return `${negative ? '-' : ''}${price.code}${value}`;
};

export const filterSavedAddressesByFallbackCountry =
  (countries: Country[], isPhysical: boolean, isSubscription?: boolean) =>
  ({ wCountry }: Address) => {
    if (isSubscription) {
      const { iso } = SiteConfig.getConfig();
      const countryBasedOnUrl = countries.find(
        ({ isoCodeTwo }) => isoCodeTwo.toUpperCase() === iso.toUpperCase()
      );

      return countryBasedOnUrl?.isoCodeTwo === wCountry;
    }

    if (!isPhysical) return true;
    return countries.some(
      ({ fallbackCountry }) => fallbackCountry === wCountry
    );
  };
